<template>
  <div class="rechargeRecord">
    <!-- 头部 -->
    <div class="head df">
      <div class="df">
        <!-- 业务时间 -->
        <div class="df seldate">
         业务时间：
          <el-date-picker
            v-model="timeQuantum"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
          >
          </el-date-picker>
        </div>
      </div>
      <!-- 功能按钮 -->
      <div class="btn df">
        <span class="b1" style="margin-right: 24px" @click="EmptyFilter">清空筛选</span>
        <div class="b2" style="color: white" @click.stop="searchs('筛选')">
          筛选
        </div>
      </div>
    </div>
    <div class='content' v-if="ISshow">
    <div class="df consumption">
      <div> 
        <span style="margin-right: 31px;">累计充值金额：￥{{amount}}</span>
        <span >充值笔数：{{total}}</span>
      </div>
      <el-button size="small" :loading="downloadLoading" plain @click="derivedData">导出</el-button>
    </div>
    <!-- 表格 -->
    <div class="tables">
        <el-table
        :data="tableData"
        style="width: 100%"
        height="100%"
        :default-sort = "{prop: 'date', order: 'descending'}"
        >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column 
          prop="createDate"
          label="充值时间"
          sortable
          >
          <template slot-scope="scope">
            <span class=" altitude">{{ scope.row.createDate?$moment(scope.row.createDate).format("YYYY-MM-DD"):'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="充值金额"
          >
        </el-table-column>
        <el-table-column
          prop="payType"
          label="付款方式"
          >
          <template slot-scope="scope">
            <span class=" altitude">{{scope.row.payType=='CT'?'月结':scope.row.payType=='CH'?'现金':scope.row.payType=='CD'?'银行卡':scope.row.payType=='OL'?'网上支付':scope.row.payType=='FC'?'到付':scope.row.payType=='DT'?'临时欠款':scope.row.payType=='PC'?'德邦E卡':''}}</span>
          </template>
        </el-table-column>

        </el-table>
        <div class="bottom" >
        <!-- v-if="totalNumber > 10" -->
        <el-pagination
          v-if="total > 10"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currpage"
          :page-sizes="[10, 20, 50]"
          :page-size="pagesize"
          layout="total,prev, pager, next, sizes,jumper"
          :total="+total"
        >
          <!-- sidebar.wayBillTotal -->
        </el-pagination>
      </div>
    </div>
    </div>
    <noContent
      style="padding-top: 100px;  text-align: center;"
      v-if="!ISshow"
      img="1"
      explain="未查询到充值记录"
    ></noContent>
  </div>
</template>

<script>
import noContent from "@/components/noContent";
import API from "../../../api/prestore";
const api = new API();
export default {
  components: { noContent },
  data() {
    return {
      downloadLoading:false,
      startDate:this.$moment().startOf('month').valueOf(),
      endDate:this.$moment().endOf('day').valueOf(),
      total:'',
      currpage:1,
      pagesize:10,
      timeQuantum: [this.$moment().startOf('month').valueOf(),this.$moment().endOf('day').valueOf()],
      ISshow: true,
      amount:'',
      tableData: []
    };
  },
  computed: {
  },
  methods: {
    // 导出
    async derivedData(){
      this.downloadLoading = true
      window.setTimeout(() => {
          this.downloadLoading = false;
      }, 7000);
      console.log('导出333');
      let parme ={
        customerName: window.localStorage.getItem("userName"),
        customerCode: window.localStorage.getItem("customerCode"),
        startDate:this.startDate,
        endDate:this.endDate,
      }
      api.printYCPayment(parme).then((res) => {
        if (res) {
          this.downloadLoading = false;
          let link = document.createElement("a");
          //    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
          let blogw = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
          link.href = objectUrl;
          link.download = decodeURI(
            escape(
              res.headers["content-disposition"]
                .replace("attachment; filename=", "")
                .replace(new RegExp('"', "gm"), "")
            )
          ); //  下载的时候的文件名
          link.click();
          window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
          // this.downloadLoading = false
          this.$message({
            message: "导出成功",
            type: "success",
          });
        } else {
          // console.log("返回数据为空");
        }
      });
    },
    // 分页 : 选择展示条数
    handleSizeChange(val) {
      this.pagesize = val;
      this.currpage = 1; // 切换 没有多少条的时候 重置为第1页开始
      console.log(`每页 ${val} 条`);
      this.searchYCPaymentMeg()
    },
    // 分页 : 换页
    handleCurrentChange(val) {
      this.currpage = val;
      console.log(`当前页: ${val}`);
      this.searchYCPaymentMeg()
    },
    // 搜索 筛选
    searchs() {
      this.startDate=this.$moment(this.timeQuantum[0]).valueOf();
      this.endDate=this.$moment(this.timeQuantum[1]).valueOf();
      this.searchYCPaymentMeg()
    },
    // 清空筛选
    EmptyFilter() {
      this.timeQuantum=[this.$moment().startOf('month').valueOf(),this.$moment().endOf('day').valueOf()],
      this.startDate=this.$moment().startOf('month').valueOf(),
      this.endDate=this.$moment().endOf('day').valueOf(), 
      this.searchYCPaymentMeg()
      // this.searchs('筛选');
    },
    async searchYCPaymentMeg() {
      let parme ={
        customerCode:window.localStorage.getItem("customerCode"),
        startDate:this.startDate,
        endDate:this.endDate,
        currentPage:this.currpage,
        pageSize:this.pagesize
      }
      let res = await api.searchYCPaymentMeg(parme);
      if(res.errorMessage){
        this.tableData = []
        this.amount = ''
        this.total = 0
        this.ISshow = false
        return
      }
      if(res.data.list.length > 0){
        this.ISshow = true
        this.tableData = res.data.list
        this.amount = res.data.amount
        this.total = res.total
        }
      
    },
  },
  created() {
    this.searchYCPaymentMeg()
  },
};
</script>

<style lang='less' scoped>
.rechargeRecord{
  width: 100%;
  height: 100%;
  background-color: #F7F7F8;
  font-size: 14px;
  font-weight: 400;
  .head {
    width: 100%;
    height: 97px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #ECECEC;
    margin-bottom: 16px;
    align-items:center;
    padding: 0 24px;
    justify-content: space-between;
    .seldate {
      color: #323233;
      line-height: 32px;
      width: 468px;
      margin: 0 32px;
      .el-input__inner {
        flex: 1;
      }
      .el-input__inner {
        width: 100%;
      }
      .el-date-editor/deep/.el-range-separator {
        width: 16px;
        padding: 0;
      }
    }
    .btn {
      font-size: 14px;
      align-items: center;
      .b1 {
        cursor: pointer;
        font-weight: 500;
        color: #008cff;
        line-height: 20px;
        &:hover {
          color: #008cffa6;
        }
      }
      .b2 {
        width: 60px;
        line-height: 32px;
        background: linear-gradient(270deg, #1a9dff 0%, #1a5eff 100%);
        box-shadow: 0px 8px 20px -6px rgba(26, 94, 255, 0.5);
        border-radius: 4px;
      }
    }
  }
  .content{
    width: 100%;
    height: 80%;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #ECECEC;
    .consumption{
      justify-content:space-between;
      line-height: 32px;
      padding: 16px 24px;
      color: #323233;
    }
  }
  .tables {
    width: 100%;
    height: 87%;
    padding: 0px 24px 66px 24px;
    .altitude {
      line-height: 31px;
    }
    .bottom {
      border-top: 1px solid #ECECEC;
      padding-top: 12px;
      text-align: left;
    }
  }
}
</style>